import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from '../shared/user/user-service.service';
import { User } from '../models/user';
import { MatPaginator, MatSort, MatTableDataSource, MatDialog } from '@angular/material';
import { CoreService } from '../shared/core/core.service';
import { UserAddComponent } from '../user-add/user-add.component';
import { DetailUserComponent } from '../components/detail-user/detail-user.component';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.css']
})
export class UsersComponent implements OnInit {
  static users: User[];
  selectedRowIndex = -1;
  displayedColumns = ['id', 'userName', 'name', 'isActive', 'createDate', 'email', 'action'];
  dataSource: any;
  isLoading = false;
  color = 'primary';
  mode = 'indeterminate';
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private userService: UserService, private core: CoreService, public dialog: MatDialog) { }

  ngOnInit() {
    this.getUsers();
  }

  getUsers(): void {
    this.isLoading = true;
    this.userService.getUsers().subscribe((users => {
      users = users;
      this.dataSource = new MatTableDataSource();
      this.dataSource.data = users;
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.isLoading = false;
    }) );
  }

  goBack(): void {
    this.core.goBack();
  }

  highlight(row) {
    this.selectedRowIndex = row.id;
}
applyFilter(filterValue: string) {
  this.dataSource.filter = filterValue.trim().toLowerCase();
}

addNewUser(): void {
  const dialogRef = this.dialog.open(UserAddComponent, {
    width: '80%'
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getUsers();
  });


}

openDialog(row): void {
  this.selectedRowIndex = row;
  const dialogRef = this.dialog.open(DetailUserComponent, {
    width: '80%',
    data: this.selectedRowIndex
  });

  dialogRef.afterClosed().subscribe(result => {
    this.getUsers();
  });
}

}
